/* eslint-disable */
import StepBase from "../../common/StepBase";

class StepEnd extends StepBase {
  constructor(scene) {
    super(scene);

    this.setupCamera();
  }

  //------------------------------------
  // Camera
  //------------------------------------
  setupCamera() {
    this.cameraRotationSpeed = -0.0025;
    this.cameraPosition = new BABYLON.Vector3(0, 0, 50);
    this.cameraTarget = new BABYLON.Vector3(0, 0, 0);
  }
}
export default StepEnd;
